import { Box, Toolbar } from "@mui/material";
import ProjectSidebar from "components/project/ProjectSidebar";
import ProjectHeader from "components/project/ProjectHeader";
import ProjectList from "components/project/ProjectList";

export default function Home() {
  return (
    <Box sx={{ display: "flex" }}>
      <ProjectHeader />
      <ProjectSidebar />
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, pt: 6, overflow: "hidden" }}
      >
        {/** Empty Toolbar to push down the content */}
        <Toolbar sx={{ minHeight: "20px !important" }} />
        <ProjectList />
      </Box>
    </Box>
  );
}
